import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import { bindActionCreators } from "redux";
import ActionGetFlow from '../../store/action/HsmTemplate/GetFlow'
import ActionGetDetailFlow from '../../store/action/FlowTemplate/GetDetailFlow'

class ButtonManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryId: 0,
            selectedType: '',
            buttonList: fromJS([]),
            buttonTemplate: fromJS({
                'button-type': '',
                'button-message': '',
                'button-value': '',
                'value-type': '',
            }),
            oneTapButtonTemplate: fromJS({
                'button-type': '',
                'button-message': '',
                'button-value': '',
                'autofill-text': '',
                'package-name': '', 
                'signature-hash': '',
                'value-type': '',
            }),
            flowButtonTemplate: fromJS({
                'button-type': 'flow',
                'button-message': '',
                'button-value': '',
                'value-type': '',
                'flow-id': '',
                'navigate-screen': '', 
                'flow-action': 'navigate',
            }),
            buttonTypes: fromJS([
                // { 'selected-type': 'Call to Action', 'selected-type-value': 'call-to-action' },
                // { 'selected-type': 'Quick Reply', 'selected-type-value': 'quick_reply' },
                { 'selected-type': 'Mix Buttons', 'selected-type-value': 'mix_button' },
            ]),
            altButtonTypes: fromJS([
                { 'selected-type': 'Copy Code', 'selected-type-value': 'copy_code'},
                { 'selected-type': 'One Tap', 'selected-type-value': 'one_tap'},
            ]),
            couponLtoButtonTypes: fromJS([
              { 'selected-type': 'Coupon / LTO', 'selected-type-value': 'coupon_lto'},
            ]),
            buttonCarouselTypes: fromJS([
              { 'selected-type': 'Button Card Carousel', 'selected-type-value': 'button_card_carousel' },
            ]),
            buttonFlowTypes: fromJS([
              { 'selected-type': 'Button Flow', 'selected-type-value': 'button_flow' },
            ]),
            buttonMpmTypes: fromJS([
              { 'selected-type': 'Button MPM', 'selected-type-value': 'button_mpm' },
            ]),
            buttonCatalogTypes: fromJS([
              { 'selected-type': 'Button Catalog', 'selected-type-value': 'button_catalog' },
            ]),
            buttonActionTypes: fromJS([
                { 'button-type': 'URL', 'button-type-value': 'URL' },
                { 'button-type': 'Phone Number', 'button-type-value': 'PHONE_NUMBER' },
                { 'button-type': 'Quick Reply', 'button-type-value': 'quick_reply' },
            ]),
            subButtonCouponLtoTypes: fromJS([
              { 'button-type': 'Copy Code', 'button-type-value': 'copy_code' },
              { 'button-type': 'URL', 'button-type-value': 'URL' },
              { 'button-type': 'Phone Number', 'button-type-value': 'PHONE_NUMBER' },
              { 'button-type': 'Quick Reply', 'button-type-value': 'quick_reply' },
            ]),
            subButtonRegulerTypes: fromJS([
              { 'button-type': 'URL', 'button-type-value': 'URL' },
              { 'button-type': 'Phone Number', 'button-type-value': 'PHONE_NUMBER' },
              { 'button-type': 'Quick Reply', 'button-type-value': 'quick_reply' },
            ]),
            buttonValueTypes: fromJS([
              { 'value-type': 'Static', 'value-type-value': 'static' },
              { 'value-type': 'Dynamic', 'value-type-value': 'dynamic' },
            ]),
            errors: fromJS({}),
            error: '',
            clientId: '',
            selectFlow: fromJS([]),
            screeenFlow: fromJS([]),
        };
        this.handleAddButton = this.handleAddButton.bind(this);
        this.handleGetFlow = this.handleGetFlow.bind(this);
    }

    handleChange(field, value, label, index) {
      const { templateType } = this.props;
        if (field === 'selected-type') {
            this.setState({
                selectedType: value,
                buttonList: fromJS([]),
            }, function () {
                if (value === 'call-to-action' || value === 'quick_reply' 
                  || value === 'copy_code' || value === 'one_tap' 
                  || value === 'coupon_lto' || value === 'button_card_carousel' 
                  || value === 'mix_button' || value === 'button_flow'
                  || value === 'button_mpm' || value === 'button_catalog'
                ) {
                    this.handleAddButton();
                }
            });

            this.setState({ buttonList: fromJS([]) }, this.passData);
            if (value === 'button_flow') {
              this.handleGetFlow();
            }
        } else {
            var buttonListCopy = this.state.buttonList;
            var buttonCopy = buttonListCopy.get(index);

            if (field === 'button-type') {
              if (value === "copy_code" && (templateType === "lto" || templateType === 'coupon')) {
                buttonCopy = buttonCopy.set('button-value', 'copy_code');
                buttonCopy = buttonCopy.set('button-message', 'Copy code');
                buttonListCopy = buttonListCopy.set(index, buttonCopy);
              } else {
                buttonCopy = buttonCopy.set('button-value', '');
                buttonCopy = buttonCopy.set('button-message', '');
                buttonListCopy = buttonListCopy.set(index, buttonCopy);
              }
            }

            if (this.state.selectedType === 'quick_reply' || this.state.selectedType === 'copy_code') {
                buttonCopy = buttonCopy.set('button-value', value);
                buttonListCopy = buttonListCopy.set(index, buttonCopy);
            } else {
              if (field === 'button-message' && buttonCopy.get('button-type') === 'quick_reply') {
                buttonCopy = buttonCopy.set('button-value', value);
                buttonListCopy = buttonListCopy.set(index, buttonCopy);
              }
            }

            if (field === 'button-message' && this.state.selectedType === 'one_tap') {
                buttonCopy = buttonCopy.set('button-value', value);
                buttonListCopy = buttonListCopy.set(index, buttonCopy);
            }

            if (field === 'value-type' && value !== 'dynamic') {
              const currentValue = buttonCopy.get('button-value')
              if (currentValue && currentValue.length && currentValue.includes('{{1}}')) {
                const newValue = currentValue.replace(/\{\{1\}\}/g, '')
                buttonCopy = buttonCopy.set('button-value', newValue);
                buttonListCopy = buttonListCopy.set(index, buttonCopy);
              }
            }

            if (field === 'button-message' && this.state.selectedType === 'button_flow') {
              buttonCopy = buttonCopy.set('button-value', value);
              buttonListCopy = buttonListCopy.set(index, buttonCopy);
            }

            if (field === 'button-message' && this.state.selectedType === 'button_mpm' || this.state.selectedType === 'button_catalog') {
              buttonCopy = buttonCopy.set('button-value', value);
              buttonListCopy = buttonListCopy.set(index, buttonCopy);
            }

            if (field === 'flow-id') {
              buttonCopy = buttonCopy.set('flow-id', value);
              buttonListCopy = buttonListCopy.set(index, buttonCopy);
              this.getDetailFlow(value);
            }

            if (field === 'navigate-screen') {
              buttonCopy = buttonCopy.set('navigate-screen', value);
              buttonListCopy = buttonListCopy.set(index, buttonCopy);
            }

            // if (buttonListCopy.get(index).get('button-type') === 'PHONE_NUMBER' && field === 'button-value') {
            //     buttonCopy = buttonCopy.set(field, value)
            //     buttonListCopy = buttonListCopy.set(index, buttonCopy);
            // } else {
            //     buttonCopy = buttonCopy.set(field, value);
            //     buttonListCopy = buttonListCopy.set(index, buttonCopy);
            // }

            // button_message is for PreviewMessage buttons props
            // if (field === 'button-message') {
                // buttonCopy = buttonCopy.set('button_message', value);
                // buttonListCopy = buttonListCopy.set(index, buttonCopy);
            // }

            buttonCopy = buttonCopy.set(field, value);
            buttonListCopy = buttonListCopy.set(index, buttonCopy);

            this.setState({ buttonList: buttonListCopy }, this.passData);
        }
    }

    async handleGetFlow() {
      var clientId = this.state.clientId;      
      var data = await this.props.actionGetFlow(clientId);
      var dataFlow = [];
      if (data) {
        data.map((item) => {
          dataFlow.push({
            'label': item.get('flow_name'),
            'value': item.get('flow_id'),
          });
        })
      }
      this.setState({
        selectFlow: dataFlow
      });
    }

    async getDetailFlow(flowId) {
      var data = await this.props.actionGetDetailFlow(flowId);
      if (data) {
        var screens = [];
        data.get('screens').map((item) => {
          screens.push({
            'label': item,
            'value': item,
          });
        })
        this.setState({
          screeenFlow: screens,
        })
      }
    }

    handleAddParamButton = (index) => {
      let buttonListCopy = this.state.buttonList;
      let buttonCopy = buttonListCopy.get(index);
      let currentValue = buttonCopy.get('button-value')
      buttonCopy = buttonCopy.set('button-value', currentValue + '{{1}}')
      buttonListCopy = buttonListCopy.set(index, buttonCopy)
      this.setState({ buttonList: buttonListCopy }, this.passData);
    }

    passData() {
        var templateButtons = this.state.buttonList;

        this.props.onChange("template-buttons", templateButtons)
    }

    handleAddButton() {
        var { buttonTemplate, buttonList, selectedType, oneTapButtonTemplate, flowButtonTemplate } = this.state;
        if (selectedType === 'quick_reply' && buttonList.size < 10) {
            buttonTemplate = buttonTemplate.set('button-type', selectedType);
            this.addButton(buttonList, buttonTemplate);
        } else if (selectedType === 'call-to-action' && buttonList.size < 3) {        
            if (buttonList.size === 0) {
                this.addButton(buttonList, buttonTemplate);
            } else if (buttonList.size === 1 && buttonList.getIn([0, 'button-type']) === 'URL') {
                let newButton = fromJS({
                    'button-type': 'PHONE_NUMBER',
                    'button-message': '',
                    'button-value': '',
                })
                this.addButton(buttonList, newButton);
            } else {
                let newButton = fromJS({
                    'button-type': 'URL',
                    'button-message': '',
                    'button-value': '',
                    'value-type': ''
                })
                 this.addButton(buttonList, newButton);
            }
        } else if (selectedType === 'copy_code' && buttonList.size < 1) {
            buttonTemplate = buttonTemplate.set('button-type', 'URL');
            // console.log(buttonTemplate,'buttonTemplate');
            this.addButton(buttonList, buttonTemplate);
        } else if (selectedType === 'one_tap' && buttonList.size < 1) {
            oneTapButtonTemplate = oneTapButtonTemplate.set('button-type', 'URL');
            this.addButton(buttonList, oneTapButtonTemplate);
        } else if (selectedType === 'coupon_lto' && buttonList.size < 2) {
          this.addButton(buttonList, buttonTemplate);
        } else if (selectedType === 'button_card_carousel' && buttonList.size < 2) {
          this.addButton(buttonList, buttonTemplate);
        } else if (selectedType === 'mix_button' && buttonList.size < 10) {
          this.addButton(buttonList, buttonTemplate);
        } else if (selectedType === 'button_flow') {
          this.addButton(buttonList, flowButtonTemplate);
        } else if (selectedType === 'button_mpm') {
          let newButton = fromJS({
              'button-type': 'MPM',
              'button-message': '',
              'button-value': '',
              'value-type': ''
          })
          this.addButton(buttonList, newButton);
        } else if (selectedType === 'button_catalog') {
          let newButton = fromJS({
              'button-type': 'CATALOG',
              'button-message': '',
              'button-value': '',
              'value-type': ''
          })
          this.addButton(buttonList, newButton);
        }
    }

    addButton(buttonList, buttonTemplate) {
        this.setState({
            buttonList: fromJS([...buttonList, buttonTemplate]),
        }, this.passData);
    }

    handleRemoveButton(index) {
      var { buttonList } = this.state
      if (buttonList.size > 0) {
        buttonList = buttonList.splice(index, 1)

        this.setState(
          {
            buttonList: buttonList,
          },
          this.passData
        )
      }
    }

    componentDidMount() {
        if (this.props.items.size > 0) {
          let type = this.props.templateType === 'lto' || this.props.templateType === 'coupon' 
              ? "coupon_lto" 
              : this.props.templateType === 'card_carousel' 
                ? "button_card_carousel"
                : this.props.templateType === 'flow' 
                  ? "button_flow"
                  : this.props.items.get(0).get('button-type').toLowerCase() === 'quick_reply' 
                      ? 'quick_reply' 
                      : this.props.categoryId !== 1 
                          ? 'call-to-action' 
                          : this.props.items.get(0).get('autofill-text') 
                              ? 'one_tap' 
                              : 'copy_code'
          this.setState({
              buttonList: this.props.items,
              selectedType: type,
              clientId : this.props.clientId,
          })
          if (this.props.templateType === 'flow') {
            this.handleGetFlow();
            this.getDetailFlow(this.props.items.get(0).get('flow-id'));
          }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.categoryId !== this.props.categoryId) {
            this.setState({
                buttonList: fromJS([]),
                selectedType: '',
                clientId: this.props.clientId,
            }, this.passData)
            // if (this.props.templateType === 'flow') {
            //   this.handleGetFlow(); 
            // }
        }
    }

    render() {
        const { buttonList, selectedType, buttonTypes, altButtonTypes, couponLtoButtonTypes, buttonCarouselTypes, buttonFlowTypes, buttonMpmTypes, buttonCatalogTypes} = this.state;
        const { categoryId, templateType, required } = this.props;
        let selections = buttonTypes;

        if (categoryId === 1) {
            selections = altButtonTypes;
        } else {
          if (templateType === "lto" || templateType === "coupon") {
            selections = couponLtoButtonTypes;
          } else if (templateType === "card_carousel") {
            selections = buttonCarouselTypes;
          } else if (templateType === "flow") {
            selections = buttonFlowTypes;
          } else if (templateType === "catalog") {
            selections = buttonCatalogTypes;
          } else if (templateType === "mpm") {
            selections = buttonMpmTypes;
          }
        }

        return (
            <>
                {(
                    <div className="row no-margin-bottom col-sm-12">
                        <span className={`${required ? 'required ' : ''}col-sm-2`}>Buttons</span>
                        <div className="col-sm-10 ">
                            <ComboboxInput
                                field='selected-type'
                                value={selectedType}
                                options={fromJS({
                                    'source': selections,
                                    'value': 'selected-type-value',
                                    'label': 'selected-type',
                                })}
                                disabled={this.props.disabled}
                                placeholder="Buttons Type"
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                            />
                        </div>
                    </div>
                )}
                {selectedType === 'mix_button' && buttonList.map((buttonValue, index) =>
                    this.renderMixButtons(buttonValue, index)
                )}
                {selectedType === 'call-to-action' && buttonList.map((buttonValue, index) =>
                    this.renderCallToAction(buttonValue, index)
                )}
                {selectedType === 'quick_reply' && buttonList.map((buttonValue, index) =>
                    this.renderQuickReply(buttonValue, index)
                )}
                {selectedType === 'copy_code' && buttonList.map((buttonValue, index) =>
                    this.renderCopyCode(buttonValue, index)
                )}
                {selectedType === 'one_tap' && buttonList.map((buttonValue, index) =>
                    this.renderOneTap(buttonValue, index)
                )}
                {selectedType === 'button_flow' && buttonList.map((buttonValue, index) =>
                    this.renderFlow(buttonValue, index)
                )}
                {(selectedType === 'button_mpm' || selectedType === 'button_catalog') && buttonList.map((buttonValue, index) =>
                    this.renderMpmCatalog(buttonValue, index)
                )}
                {(selectedType === 'coupon_lto' || selectedType === 'button_card_carousel') && buttonList.map((buttonValue, index) =>
                    this.renderGeneralButtonTypes(buttonValue, index)
                )}
            </>
        );
    }

    renderMpmCatalog(buttonValue, index) {
      const { errors } = this.state;
      return (
        <div key={index} className="call-to-action row no-margin-bottom col-sm-12">
          <div className="col-sm-10 pull-right">
            <div className="row">
              <div className="col-sm-10 pr-5">
                <TextInputField
                  field={'button-message'}
                  value={buttonValue.get('button-message')}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  placeholder="Button Message (max 25 characters)"
                  maxLength={25}
                  disabled={this.props.disabled}
                  hasError={errors.has('button-message')}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    renderFlow(buttonValue, index) {
      const { errors, selectFlow, screeenFlow } = this.state;      
      return (
        <div key={index} className="call-to-action row no-margin-bottom col-sm-12">
          <div className="col-sm-10 pull-right">
            <div className="row">
              <div className="col-sm-10 pr-5">
                <TextInputField
                  field={'button-message'}
                  value={buttonValue.get('button-message')}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  placeholder="Button Message (max 20 characters)"
                  maxLength={20}
                  disabled={this.props.disabled}
                  hasError={errors.has('button-message')}
                />
              </div>
              <div className="col-sm-10 pr-5">
                <ComboboxInput
                  field="flow-id"
                  value={buttonValue.get('flow-id')}
                  options={fromJS({
                    source: selectFlow,
                    value: 'value',
                    label: 'label',
                  })}
                  placeholder="Select Flow Name"
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  hasError={errors.has('flow-id')}
                />
              </div>
              <div className="col-sm-10 pr-5">
                <ComboboxInput
                  field="navigate-screen"
                  value={buttonValue.get('navigate-screen')}
                  options={fromJS({
                    source: screeenFlow,
                    value: 'value',
                    label: 'label',
                  })}
                  placeholder="Select Flow Navigate Screen"
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  hasError={errors.has('navigate-screen')}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    renderMixButtons(buttonValue, index) {
      const { errors, buttonActionTypes, buttonList, buttonValueTypes } = this.state;
      return (
        <div key={index} className="call-to-action row no-margin-bottom col-sm-12">
          <div className="col-sm-10 pull-right">
            <div className="row">
              <div className="col-sm-10 pr-5">
                <ComboboxInput
                  field="button-type"
                  value={buttonValue.get('button-type')}
                  options={fromJS({
                    source: buttonActionTypes,
                    value: 'button-type-value',
                    label: 'button-type',
                  })}
                  disabled={
                    (buttonList.size > 10 ? true : false) ||
                    this.props.disabled
                  }
                  placeholder="Button Sub-Type"
                  // onChange={(field, value, label) =>
                  //   this.handleChange(field, value, label, index)
                  // }
                  onChange={(field, value, label) => {
                      let buttonPhone = buttonList.filter(button => button.get('button-type') === 'PHONE_NUMBER').count();
                      let buttonUrl = buttonList.filter(button => button.get('button-type') === 'URL').count();
                      if (buttonPhone < 1 && value === 'PHONE_NUMBER') {
                        this.handleChange(field, value, label, index)
                      }
                      if (buttonUrl < 2 && value === 'URL') {
                        this.handleChange(field, value, label, index)
                      }
                      if (value === 'quick_reply') {
                        this.handleChange(field, value, label, index)
                      }
                    }
                  }
                />
              </div>
              
              {!this.props.disabled && buttonList.size > 1 && (
                <div className="col-sm-2 pl-0">
                  <button
                    onClick={() => this.handleRemoveButton(index)}
                    className="btn btn-danger"
                  >
                    Remove Button
                  </button>
                </div>
              )}
            </div>
            {buttonList.get(index).get('button-type') === 'URL' && (
              <div>
               <div className="row">
                 <div className="col-sm-10 pr-5">
                   <TextInputField
                     field={'button-message'}
                     value={buttonValue.get('button-message')}
                     onChange={(field, value, label) =>
                       this.handleChange(field, value, label, index)
                     }
                     placeholder="Button Message (max 20 characters)"
                     maxLength={20}
                     disabled={this.props.disabled}
                     hasError={errors.has('button-message')}
                   />
                 </div>
                </div>
                <div className="row">
                  <div className="col-sm-10 pr-5">
                    <ComboboxInput
                      field="value-type"
                      value={buttonValue.get('value-type')}
                      options={fromJS({
                        source: buttonValueTypes,
                        value: 'value-type-value',
                        label: 'value-type',
                      })}
                      placeholder="URL Type"
                      onChange={(field, value, label) =>
                        this.handleChange(field, value, label, index)
                      }
                      hasError={errors.has('value-type')}
                    />
                  </div>
                </div>
                <div className="row">
                 <div className="col-sm-9 pr-5">
                   <TextInputField
                     autoCapitalize="none"
                     field={'button-value'}
                     value={buttonValue.get('button-value')}
                     onChange={(field, value, label) => 
                      this.handleChange(field, value, label, index)
                     }
                     placeholder="URL Link"
                     disabled={this.props.disabled}
                     hasError={errors.has('button-value')}
                   />
                 </div>
                 <div className="col-sm-1 p-0">
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        style={{marginLeft: -20}}
                        onClick={() => this.handleAddParamButton(index)}
                        disabled={
                          this.props.disabled ||
                          buttonList.get(index).get('value-type') != 'dynamic' ||
                          buttonList.get(index).get('button-value').includes('{{1}}')
                        }
                    >
                        {"{{}}"}
                    </button>    
                  </div>
                 {!this.props.disabled &&
                   buttonList.size - 1 === index &&
                   buttonList.size < 10 && (
                    <div className="col-sm-2 p-0">
                      <button
                        onClick={this.handleAddButton}
                        className="btn btn-success"
                      >
                        Add Button
                      </button>
                    </div>
                   )}
                </div>
              </div>
            )}
            {buttonList.get(index).get('button-type') === 'PHONE_NUMBER' && (
              <div className="row">
                <div className="col-sm-5 pr-5">
                  <TextInputField
                    field={'button-message'}
                    value={buttonValue.get('button-message')}
                    onChange={(field, value, label) =>
                      this.handleChange(field, value, label, index)
                    }
                    placeholder="Button Message (max 20 characters)"
                    maxLength={20}
                    disabled={this.props.disabled}
                    hasError={errors.has('button-message')}
                  />
                </div>
                <div className="col-sm-5 pl-0 pr-5">
                  <TextInputField
                    field={'button-value'}
                    value={buttonValue.get('button-value')}
                    onChange={(field, value, label) =>
                      this.handleChange(field, value, label, index)
                    }
                    placeholder="Phone Number"
                    disabled={this.props.disabled}
                    hasError={errors.has('button-value')}
                  />
                </div>
                {!this.props.disabled &&
                  buttonList.size - 1 === index &&
                  buttonList.size < 10 && (
                    <div className="col-sm-2">
                      <button
                        onClick={this.handleAddButton}
                        className="btn btn-success"
                      >
                        Add Button
                      </button>
                    </div>
                  )}
              </div>
            )}
            {buttonList.get(index).get('button-type') === 'quick_reply' && (
              <div className="row">
                <div className="col-sm-10 pr-5">
                  <TextInputField
                    field={'button-message'}
                    value={buttonValue.get('button-message')}
                    onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                    placeholder="Button Message (max 25 characters)"
                    maxLength={25}
                    disabled={this.props.disabled}
                    hasError={errors.has('button-message')}
                  />
                </div>
                {!this.props.disabled &&
                  buttonList.size - 1 === index &&
                  buttonList.size < 10 && (
                    <div className="col-sm-2">
                      <button
                        onClick={this.handleAddButton}
                        className="btn btn-success"
                      >
                        Add Button
                      </button>
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      )
    }

    renderCopyCode(buttonValue, index) {
        const { errors } = this.state;

        return (
            <div key={index} className="copy-code row no-margin-bottom col-sm-12">
                <div className="col-sm-10 pull-right">
                    <div className="row">
                        <div className="col-sm-9 pr-5">
                            <TextInputField
                                field={'button-message'}
                                value={buttonValue.get('button-message')}
                                onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                                placeholder="Copy Code (max 20 characters)"
                                maxLength={20}
                                disabled={this.props.disabled}
                                hasError={errors.has('button-message')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderOneTap(buttonValue, index) {
        const { errors } = this.state;

        return (
            <div key={index} className="one-tap row no-margin-bottom col-sm-12">
                <div className="col-sm-10 pull-right">
                    <div className="row">
                        <div className="col-sm-9 pr-5">
                            <TextInputField
                                field={'button-message'}
                                value={buttonValue.get('button-message')}
                                onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                                placeholder="One Time Password (max 20 characters)"
                                maxLength={20}
                                disabled={this.props.disabled}
                                hasError={errors.has('button-message')}
                            />
                        </div>
                        <div className="col-sm-9 pr-5">
                            <TextInputField
                                field={'autofill-text'}
                                value={buttonValue.get('autofill-text')}
                                onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                                placeholder="Autofill Text"
                                maxLength={100}
                                disabled={this.props.disabled}
                                hasError={errors.has('autofill-text')}
                            />
                        </div>
                        <div className="col-sm-9 pr-5">
                            <TextInputField
                                field={'package-name'}
                                value={buttonValue.get('package-name')}
                                onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                                placeholder="Package Name"
                                maxLength={100}
                                disabled={this.props.disabled}
                                hasError={errors.has('package-name')}
                            />
                        </div>
                        <div className="col-sm-9 pr-5">
                            <TextInputField
                                field={'signature-hash'}
                                value={buttonValue.get('signature-hash')}
                                onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                                placeholder="Signature Hash"
                                maxLength={100}
                                disabled={this.props.disabled}
                                hasError={errors.has('signature-hash')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderQuickReply(buttonValue, index) {
        const { errors } = this.state;

        return (
            <div key={index} className="quick-reply row no-margin-bottom col-sm-12">
                <div className="col-sm-10 pull-right">
                    <div className="row">
                        <div className="col-sm-9 pr-5">
                            <TextInputField
                                field={'button-message'}
                                value={buttonValue.get('button-message')}
                                onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                                placeholder="Button Message (max 25 characters)"
                                maxLength={25}
                                disabled={this.props.disabled}
                                hasError={errors.has('button-message')}
                            />
                        </div>

                        <div className="col-sm-3 pl-0">
                            {!this.props.disabled && this.state.buttonList.size - 1 === index && this.state.buttonList.size < 10 && (
                                <button onClick={this.handleAddButton} className="btn btn-success no-margin-bottom col-sm-12">Add Button</button>
                            )}
                            {!this.props.disabled && this.state.buttonList.size > 1 && (
                                <button onClick={() => this.handleRemoveButton(index)} className="btn btn-danger no-margin-bottom col-sm-12">Remove Button</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCallToAction(buttonValue, index) {
        const { errors, buttonActionTypes, buttonList, buttonValueTypes } = this.state;
        return (
          <div key={index} className="call-to-action row no-margin-bottom col-sm-12">
            <div className="col-sm-10 pull-right">
              <div className="row">
                <div className="col-sm-10 pr-5">
                  <ComboboxInput
                    field="button-type"
                    value={buttonValue.get('button-type')}
                    options={fromJS({
                      source: buttonActionTypes,
                      value: 'button-type-value',
                      label: 'button-type',
                    })}
                    disabled={
                      (buttonList.size > 2 ? true : false) ||
                      this.props.disabled
                    }
                    placeholder="Button Sub-Type"
                    onChange={(field, value, label) =>
                      this.handleChange(field, value, label, index)
                    }
                  />
                </div>
                {!this.props.disabled && buttonList.size > 2 && (
                  <div className="col-sm-2 pl-0">
                    <button
                      onClick={() => this.handleRemoveButton(index)}
                      className="btn btn-danger"
                    >
                      Remove Button
                    </button>
                  </div>
                )}
              </div>
              {buttonList.get(index).get('button-type') === 'URL' && (
                <div>
                 <div className="row">
                   <div className="col-sm-10 pr-5">
                     <TextInputField
                       field={'button-message'}
                       value={buttonValue.get('button-message')}
                       onChange={(field, value, label) =>
                         this.handleChange(field, value, label, index)
                       }
                       placeholder="Button Message (max 20 characters)"
                       maxLength={20}
                       disabled={this.props.disabled}
                       hasError={errors.has('button-message')}
                     />
                   </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-10 pr-5">
                      <ComboboxInput
                        field="value-type"
                        value={buttonValue.get('value-type')}
                        options={fromJS({
                          source: buttonValueTypes,
                          value: 'value-type-value',
                          label: 'value-type',
                        })}
                        placeholder="URL Type"
                        onChange={(field, value, label) =>
                          this.handleChange(field, value, label, index)
                        }
                        hasError={errors.has('value-type')}
                      />
                    </div>
                  </div>
                  <div className="row">
                   <div className="col-sm-9 pr-5">
                     <TextInputField
                       autoCapitalize="none"
                       field={'button-value'}
                       value={buttonValue.get('button-value')}
                       onChange={(field, value, label) => 
                        this.handleChange(field, value, label, index)
                       }
                       placeholder="URL Link"
                       disabled={this.props.disabled}
                       hasError={errors.has('button-value')}
                     />
                   </div>
                   <div className="col-sm-1 p-0">
                      <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          style={{marginLeft: -20}}
                          onClick={() => this.handleAddParamButton(index)}
                          disabled={
                            this.props.disabled ||
                            buttonList.get(index).get('value-type') != 'dynamic' ||
                            buttonList.get(index).get('button-value').includes('{{1}}')
                          }
                      >
                          {"{{}}"}
                      </button>    
                    </div>
                   {!this.props.disabled &&
                     buttonList.size - 1 === index &&
                     buttonList.size < 3 && (
                      <div className="col-sm-2 p-0">
                        <button
                          onClick={this.handleAddButton}
                          className="btn btn-success"
                        >
                          Add Button
                        </button>
                      </div>
                     )}
                  </div>
                </div>
              )}
              {buttonList.get(index).get('button-type') === 'PHONE_NUMBER' && (
                <div className="row">
                  <div className="col-sm-5 pr-5">
                    <TextInputField
                      field={'button-message'}
                      value={buttonValue.get('button-message')}
                      onChange={(field, value, label) =>
                        this.handleChange(field, value, label, index)
                      }
                      placeholder="Button Message (max 20 characters)"
                      maxLength={20}
                      disabled={this.props.disabled}
                      hasError={errors.has('button-message')}
                    />
                  </div>
                  <div className="col-sm-5 pl-0 pr-5">
                    <TextInputField
                      field={'button-value'}
                      value={buttonValue.get('button-value')}
                      onChange={(field, value, label) =>
                        this.handleChange(field, value, label, index)
                      }
                      placeholder="Phone Number"
                      disabled={this.props.disabled}
                      hasError={errors.has('button-value')}
                    />
                  </div>
                  {!this.props.disabled &&
                    buttonList.size - 1 === index &&
                    buttonList.size < 3 && (
                      <div className="col-sm-2">
                        <button
                          onClick={this.handleAddButton}
                          className="btn btn-success"
                        >
                          Add Button
                        </button>
                      </div>
                    )}
                </div>
              )}
            </div>
          </div>
        )
    }

    renderGeneralButtonTypes(buttonValue, index) {
      const { errors, subButtonCouponLtoTypes, subButtonRegulerTypes, buttonList, buttonValueTypes } = this.state;
      const { templateType } = this.props;
      const limitButton = (templateType === "card_carousel" || templateType === "lto") ? 2 : 10;

      return (
        <div key={index} className="call-to-action row no-margin-bottom col-sm-12">
          <div className="col-sm-10 pull-right">
            <div className="row">
              <div className="col-sm-10 pr-5">
                <ComboboxInput
                  field="button-type"
                  value={buttonValue.get('button-type')}
                  options={fromJS({
                    source: templateType === "card_carousel" ? subButtonRegulerTypes : subButtonCouponLtoTypes,
                    value: 'button-type-value',
                    label: 'button-type',
                  })}
                  disabled={this.props.disabled}
                  placeholder="Button Sub-Type"
                  onChange={(field, value, label) => {
                    let addable = true;
                      buttonList.forEach(btn => {
                        if (value !== "quick_reply" && btn.get('button-type') === value) {
                          addable = false;
                        }
                      });
                      if (addable) {
                        this.handleChange(field, value, label, index)
                      }
                  }
                  }
                />
              </div>
              {!this.props.disabled && buttonList.size > 1 && (
                <div className="col-sm-2 pl-0">
                  <button
                    onClick={() => this.handleRemoveButton(index)}
                    className="btn btn-danger"
                  >
                    Remove Button
                  </button>
                </div>
              )}
            </div>
            {buttonList.get(index).get('button-type') === 'URL' && (
              <div>
               <div className="row">
                 <div className="col-sm-10 pr-5">
                   <TextInputField
                     field={'button-message'}
                     value={buttonValue.get('button-message')}
                     onChange={(field, value, label) =>
                       this.handleChange(field, value, label, index)
                     }
                     placeholder="Button Message (max 20 characters)"
                     maxLength={20}
                     disabled={this.props.disabled}
                     hasError={errors.has('button-message')}
                   />
                 </div>
                </div>
                <div className="row">
                  <div className="col-sm-10 pr-5">
                    <ComboboxInput
                      field="value-type"
                      value={buttonValue.get('value-type')}
                      options={fromJS({
                        source: buttonValueTypes,
                        value: 'value-type-value',
                        label: 'value-type',
                      })}
                      placeholder="URL Type"
                      onChange={(field, value, label) =>
                        this.handleChange(field, value, label, index)
                      }
                      hasError={errors.has('value-type')}
                    />
                  </div>
                </div>
                <div className="row">
                 <div className="col-sm-9 pr-5">
                   <TextInputField
                     autoCapitalize="none"
                     field={'button-value'}
                     value={buttonValue.get('button-value')}
                     onChange={(field, value, label) => 
                      this.handleChange(field, value, label, index)
                     }
                     placeholder="URL Link"
                     disabled={this.props.disabled}
                     hasError={errors.has('button-value')}
                   />
                 </div>
                 <div className="col-sm-1 p-0">
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        style={{marginLeft: -20}}
                        onClick={() => this.handleAddParamButton(index)}
                        disabled={
                          this.props.disabled ||
                          buttonList.get(index).get('value-type') != 'dynamic' ||
                          buttonList.get(index).get('button-value').includes('{{1}}')
                        }
                    >
                        {"{{}}"}
                    </button>    
                  </div>
                 {!this.props.disabled &&
                   buttonList.size - 1 === index &&
                   buttonList.size < limitButton && (
                    <div className="col-sm-2 p-0">
                      <button
                        onClick={this.handleAddButton}
                        className="btn btn-success"
                      >
                        Add Button
                      </button>
                    </div>
                   )}
                </div>
              </div>
            )}
            {buttonList.get(index).get('button-type') === 'PHONE_NUMBER' && (
                <div className="row">
                  <div className="col-sm-5 pr-5">
                    <TextInputField
                      field={'button-message'}
                      value={buttonValue.get('button-message')}
                      onChange={(field, value, label) =>
                        this.handleChange(field, value, label, index)
                      }
                      placeholder="Button Message (max 20 characters)"
                      maxLength={20}
                      disabled={this.props.disabled}
                      hasError={errors.has('button-message')}
                    />
                  </div>
                  <div className="col-sm-5 pl-0 pr-5">
                    <TextInputField
                      field={'button-value'}
                      value={buttonValue.get('button-value')}
                      onChange={(field, value, label) =>
                        this.handleChange(field, value, label, index)
                      }
                      placeholder="Phone Number"
                      disabled={this.props.disabled}
                      hasError={errors.has('button-value')}
                    />
                  </div>
                  {!this.props.disabled &&
                    buttonList.size - 1 === index &&
                    buttonList.size < limitButton && (
                      <div className="col-sm-2">
                        <button
                          onClick={this.handleAddButton}
                          className="btn btn-success"
                        >
                          Add Button
                        </button>
                      </div>
                    )}
                </div>
              )}
            {buttonList.get(index).get('button-type') === 'quick_reply' && (
              <div className="row">
                <div className="col-sm-9 pr-5">
                    <TextInputField
                        field={'button-message'}
                        value={buttonValue.get('button-message')}
                        onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                        placeholder="Button Message (max 25 characters)"
                        maxLength={25}
                        disabled={this.props.disabled}
                        hasError={errors.has('button-message')}
                    />
                </div>
                {!this.props.disabled &&
                  buttonList.size - 1 === index &&
                  buttonList.size < limitButton && (
                    <div className="col-sm-2">
                      <button
                        onClick={this.handleAddButton}
                        className="btn btn-success"
                      >
                        Add Button
                      </button>
                    </div>
                  )}
              </div>
            )}
            {buttonList.get(index).get('button-type') === 'copy_code' && (
            <div className="row">
                <div className="col-sm-9 pr-5">
                    <TextInputField
                        field={'button-message'}
                        value={buttonValue.get('button-message') || "Copy code"}
                        disabled={true}
                        hasError={errors.has('button-message')}
                    />
                </div>
                {!this.props.disabled &&
                  buttonList.size - 1 === index &&
                  buttonList.size < limitButton && (
                    <div className="col-sm-2">
                      <button
                        onClick={this.handleAddButton}
                        className="btn btn-success"
                      >
                        Add Button
                      </button>
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      )
    }
}

export default connect(
  (state) => {
    return {
    };
  },
  (dispatch) =>
    bindActionCreators(
      {
        actionGetFlow: ActionGetFlow,
        actionGetDetailFlow: ActionGetDetailFlow,
      },
    dispatch
  )
)(ButtonManager);